import { render, staticRenderFns } from "./Welcome-teste.vue?vue&type=template&id=5e045ab3&"
import script from "./Welcome-teste.vue?vue&type=script&lang=js&"
export * from "./Welcome-teste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports